import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Logout from '@mui/icons-material/Logout';
import CollectionsIcon from '@mui/icons-material/Collections';
import { HELPERS } from '../../../helpers'
import { useHistory } from "react-router-dom";
import Moment from 'react-moment';
import PortraitIcon from '@mui/icons-material/Portrait';

export default function UserTab({ user, logout }) {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const goTo = (path) => {
    history.push(`/${path}`);
  };


  return (
    <React.Fragment>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }} className="user-nav-bar">
        <h6 className='user-name'>{user?.first_name}</h6>
        <Tooltip title="Account">
          <IconButton
            onClick={handleClick}
            size="small"
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            className='user-icon-btn'
          >
            <Avatar sx={{ width: 30, height: 30 }}>{HELPERS.firstLetterPicker(user?.first_name)}</Avatar>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >

        <MenuItem onClick={() => goTo('face-scan')}>
          <ListItemIcon>
            <PortraitIcon fontSize='medium' />
          </ListItemIcon>
          Attendance
        </MenuItem>


        <MenuItem onClick={() => goTo('face-gallery')}>
          <ListItemIcon>
            <CollectionsIcon fontSize='small' />
          </ListItemIcon>
          Face Gallery
        </MenuItem>


        <MenuItem onClick={logout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>

        <h6 className='login-time'>
          Last Login- <Moment date={user?.lastLogin} format="MMM Do, y h:mm:ss a" />
        </h6>
      </Menu>
    </React.Fragment>
  );
}
